/**
 * WhatsApp Mixin
 *
 * Provides WhatsApp promo card and enable drawer functionality.
 *
 * Requirements:
 * - Component must include Services mixin
 * - Component must have refs: whatsAppPromoCard, whatsAppEnableDrawer
 * - Component template must include:
 *   <WhatsAppPromoCard ref="whatsAppPromoCard" @action="handleWhatsAppAction" />
 *   <WhatsAppEnableDrawer ref="whatsAppEnableDrawer" @enable="handleEnableWhatsApp" @done="handleWhatsAppEnableDone" @closed="handleWhatsAppDrawerClosed" />
 */
export default {
	methods: {
		handleWhatsAppAction() {
			// Reload customer from server to get current whatsAppEnabled state
			this._clearCustomer();
			this.customer = null;
			this._getCustomer(() => {
				if (this.customer.person.whatsAppEnabled) {
					this._sendWhatsAppNotification("You indicated you wanted to send a document 📄  Just drop it here and we will upload and process it for you 👍", this.customer.person.mobilePhone);
					// Change button to "sent" state after component is re-mounted
					this.$nextTick(() => {
						if (this.$refs.whatsAppPromoCard) {
							this.$refs.whatsAppPromoCard.setClicked();
						}
					});
				} else {
					// Open the enable WhatsApp drawer (don't change button state)
					if (this.$refs.whatsAppEnableDrawer) {
						this.$refs.whatsAppEnableDrawer.openDrawer();
					}
				}
			});
		},
		handleEnableWhatsApp() {
			this._enableWhatsApp();
		},
		handleWhatsAppEnableDone() {
			// Refresh customer to get updated whatsAppEnabled status
			this._clearCustomer();
			this._getCustomer();
			// Reset the promo card to initial state
			if (this.$refs.whatsAppPromoCard) {
				this.$refs.whatsAppPromoCard.reset();
			}
		},
		handleWhatsAppDrawerClosed() {
			// Reset the promo card when drawer is closed
			if (this.$refs.whatsAppPromoCard) {
				this.$refs.whatsAppPromoCard.reset();
			}
		}
	}
}
